import { Route } from '@angular/router';
import { WrapperComponent } from './pages/wrapper/wrapper.component';
import { HomeComponent } from './pages/home/home.component';
import { DetailComponent } from './pages/detail/detail.component';
import { AuthComponent } from './pages/auth/auth.component';
import { BookingComponent } from './pages/booking/booking.component';
import { AuthGuard } from './guards/auth.guard';
import { InitUserGuard } from './guards/init-user.guard';
import { NoAccessComponent } from './pages/no-access/no-access.component';
import { FavoritesComponent } from './pages/favorites/favorites.component';
import { ShareComponent } from './pages/share/share.component';
import { KampasComponent } from './pages/kampas/kampas.component';
import { TypeSelectorComponent } from './pages/type-selector/type-selector.component';

export const appRoutes: Route[] = [
	{
		path: 'auth',
		component: AuthComponent,
	},
	{
		path: '',
		component: WrapperComponent,
		canActivate: [InitUserGuard],
		children: [
			{
				path: '',
				component: HomeComponent,
			},
			{
				path: 'kampas',
				component: KampasComponent,
			},
			{
				path: 'offers/:id',
				component: DetailComponent,
			},
			{
				path: 'qr/:id',
				component: DetailComponent,
			},
			{
				path: 'offers/:id/denied',
				component: NoAccessComponent,
			},
			{
				path: 'offers/:id/booking',
				component: BookingComponent,
				canActivate: [AuthGuard],
				data: {
					authRoles: ['eligibleForDiscount', 'socialOrg'],
				},
			},
			{
				path: 'favorites',
				component: FavoritesComponent,
			},
			{
				path: 'favorites/:id',
				component: DetailComponent,
				data: {
					backRoute: ['/', 'favorites'],
				},
			},
			{
				path: 'share',
				component: ShareComponent,
			},
			{
				path: 'share/:id',
				component: DetailComponent,
				data: {
					backRoute: ['/', 'share'],
				},
			},
			{
				path: ':type',
				component: TypeSelectorComponent,
			},
		],
	},
];
